<template>
    <div>
        <h1>Frontend using Angular</h1>
        <p>Congrats! Frontend using Angular is a great stack!</p>

        <FrontendTechReq></FrontendTechReq>

        <h3>Angular-specific requirements</h3>
        <ul>
            <li>Lorem Ipsum</li>
        </ul>
        <h3>Navigation</h3>
        <LinkBox>
            <li><router-link to="/frontend">Return: Mission</router-link></li>
            <li><router-link to="/frontend-deploy">Goto: Deploy to the cloud</router-link></li>
        </LinkBox>
    </div>
</template>



<script>
import LinkBox from '@/components/LinkBox.vue'
import FrontendTechReq from '@/components/FrontendTechReq.vue'

export default {
    name: 'FrontendAngular',
    components: {
        LinkBox,
        FrontendTechReq
    }
}
</script>